import React from 'react';
import { CTAButton } from './CTAButton';
import { LockIcon, ShieldCheckIcon, ZapIcon, HeadphonesIcon, BookOpenIcon } from 'lucide-react';
export function PriceBlock() {
  return <section id="price-block" className="py-16 px-4 relative" data-id="element-221">
      {/* Background radial gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(201,168,76,0.15)_0%,transparent_60%)] pointer-events-none" data-id="element-222"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-223">
        <div className="glass-card border-gold-500/50 bg-zinc-950/80 p-8 md:p-12 shadow-[0_0_80px_rgba(201,168,76,0.15)] rounded-3xl relative overflow-hidden" data-id="element-224">
          {/* Animated border glow */}
          <div className="absolute inset-0 border-2 border-gold-500/20 rounded-3xl pointer-events-none" data-id="element-225"></div>
          <div className="absolute top-0 left-1/4 right-1/4 h-px bg-gold-gradient shadow-[0_0_20px_rgba(201,168,76,1)]" data-id="element-226"></div>

          <div className="inline-flex items-center gap-2 px-4 py-1.5 text-sm font-bold tracking-widest text-gold-950 bg-gold-gradient uppercase rounded-full shadow-lg mb-8" data-id="element-227">
            <ZapIcon className="w-4 h-4" data-id="element-228" />
            EXCLUSIVE OFFER — LIMITED TIME
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 font-serif" data-id="element-229">
            History is not written by those who stay silent
          </h2>

          {/* eBook Cover */}
          <div className="flex justify-center py-6" data-id="element-230">
            <div className="relative" data-id="element-231">
              <div className="absolute -inset-6 bg-gold-500/10 blur-3xl rounded-full pointer-events-none" data-id="element-232"></div>
              <img src="https://cdn.magicpatterns.com/uploads/eQzqZdVop5T2cqa11AGZRp/cover.png" alt="The Voice They Couldn't Silence — eBook Cover" className="relative w-48 md:w-64 h-auto drop-shadow-[0_20px_50px_rgba(201,168,76,0.3)]" data-id="element-233" />
            </div>
          </div>

          <p className="text-lg md:text-xl text-zinc-400 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-234">
            But by those who dare to speak when the cost is highest. Don't just
            buy an eBook;{' '}
            <strong className="text-gold-100" data-id="element-235">
              acquire an insurance policy for your free will.
            </strong>
          </p>

          {/* What's included */}
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8" data-id="element-236">
            <div className="flex items-center gap-3 px-5 py-3 rounded-xl bg-white/[0.03] border border-white/10" data-id="element-237">
              <BookOpenIcon className="w-5 h-5 text-gold-400" data-id="element-238" />
              <span className="text-zinc-200 font-medium" data-id="element-239">eBook PDF</span>
            </div>
            <div className="flex items-center gap-2 text-gold-500 font-bold text-xl" data-id="element-240">
              +
            </div>
            <div className="flex items-center gap-3 px-5 py-3 rounded-xl bg-gold-950/30 border border-gold-500/30 shadow-[0_0_15px_rgba(201,168,76,0.1)]" data-id="element-241">
              <HeadphonesIcon className="w-5 h-5 text-gold-400" data-id="element-242" />
              <span className="text-gold-100 font-medium" data-id="element-243">Audiobook MP3</span>
              <span className="text-[10px] font-bold tracking-widest text-gold-950 bg-gold-gradient px-2 py-0.5 rounded-full uppercase" data-id="element-244">
                Bonus
              </span>
            </div>
          </div>

          <div className="py-8 border-y border-gold-900/30 mb-8 bg-gold-950/10 rounded-xl" data-id="element-245">
            <div className="flex flex-col items-center justify-center gap-4" data-id="element-246">
              <div className="flex items-center gap-4" data-id="element-247">
                <span className="text-3xl text-zinc-500 line-through font-bold" data-id="element-248">
                  $97.00
                </span>
                <span className="bg-red-500/20 text-red-400 px-3 py-1 rounded-full text-sm font-bold border border-red-500/30" data-id="element-249">
                  SAVE 82%
                </span>
              </div>
              <div className="flex items-start justify-center gap-2" data-id="element-250">
                <span className="text-4xl text-gold-500 font-bold mt-2" data-id="element-251">$</span>
                <span className="text-7xl md:text-9xl font-black text-transparent bg-clip-text bg-gold-gradient tracking-tighter drop-shadow-lg" data-id="element-252">
                  17
                </span>
              </div>
              <p className="text-gold-500 font-mono uppercase tracking-widest mt-2" data-id="element-253">
                One-Time Payment • Instant Access
              </p>
            </div>
          </div>

          <div className="space-y-6 flex flex-col items-center" data-id="element-254">
            <div className="w-full max-w-xl" data-id="element-255">
              <CTAButton onClick={() => {
              if (window.fbq) {
                window.fbq('track', 'AddToCart', {
                  content_name: "The Voice They Couldn't Silence — eBook + Audiobook",
                  content_type: 'product',
                  value: 17.0,
                  currency: 'USD'
                });
              }
              window.open('https://www.simplementemejor.com/cart/51730114642200:1', '_blank');
            }} className="w-full text-lg md:text-xl py-6 shadow-[0_0_40px_rgba(201,168,76,0.4)] hover:shadow-[0_0_60px_rgba(201,168,76,0.6)]" data-id="element-256">
                YES, I WANT INSTANT ACCESS FOR JUST $17
              </CTAButton>
            </div>

            <p className="text-red-400 font-bold animate-pulse" data-id="element-257">
              Only 147 copies remaining at this price
            </p>

            <div className="flex flex-wrap justify-center gap-6 text-sm text-zinc-400 pt-4 border-t border-white/5" data-id="element-258">
              <span className="flex items-center gap-2" data-id="element-259">
                <LockIcon className="w-4 h-4 text-gold-500" data-id="element-260" />
                256-bit SSL Encryption
              </span>
              <span className="flex items-center gap-2" data-id="element-261">
                <ZapIcon className="w-4 h-4 text-gold-500" data-id="element-262" />
                Instant Digital Delivery
              </span>
              <span className="flex items-center gap-2" data-id="element-263">
                <ShieldCheckIcon className="w-4 h-4 text-gold-500" data-id="element-264" />
                30-Day Guarantee
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}